import CopyRight from "./components/copy-right";
import Information from "./components/information";

const Footer = () => {
    return (
        <div className="bg-black">
            <Information />
            <CopyRight />
        </div>
    )
}

export default Footer;